export const sortSelectOptions = (
  options: readonly any[],
  getTranslation: (value: string) => string,
  optionsNumbersLast?: boolean
) => {
  return [...options].sort((a, b) => {
    if (!a.value && b.value) return -1;
    if (a.value && !b.value) return 1;
    if (!a.value && !b.value) return 0;

    const textA = getTranslation(a.value);
    const textB = getTranslation(b.value);

    if (optionsNumbersLast) {
      const startsWithNumberA = /^\d/.test(textA);
      const startsWithNumberB = /^\d/.test(textB);

      if (startsWithNumberA && startsWithNumberB) {
        return textA.localeCompare(textB);
      }
      if (startsWithNumberA) return 1;
      if (startsWithNumberB) return -1;
    }

    return textA.localeCompare(textB);
  });
};
